import { getPortalSdk } from 'portal-sdk';
import { useQuery } from 'react-query';
import { isDevelopment } from 'vet-bones/utils';

import { QUERY_STALE_TIME } from 'src/constants/limits';

export type PortalFeatures = {
  voiceBox: boolean;
};
export const defaultPortalFeatures: PortalFeatures = {
  voiceBox: false,
};

export const usePortalFeatures = () => {
  return useQuery(
    ['usePortalFeatures'],
    async () => {
      const sdk = getPortalSdk();
      if (!sdk) {
        return null;
      }
      const profile = await sdk.profile();
      const isVoiceboxEnabled = profile?.is_staff || isDevelopment();
      const portalFeatures: PortalFeatures = {
        voiceBox: isVoiceboxEnabled,
      };
      return portalFeatures;
    },
    { refetchOnWindowFocus: false, staleTime: QUERY_STALE_TIME }
  );
};
